module.exports = __webpack_public_path__ + "static/img/kc2.af55a6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/course/kc2.png
// module id = p0EA
// module chunks = 0